<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_count_entry.actual_count_entry') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t(
            'inventory.operation.stock_count_entry.actual_count_entry'
          ),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-9">
            <ts-button color="info" outline @click="$router.push({ name: 'stock-count-entry-create' })">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" class="mr-2" />
            <ts-button outline v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.scnt_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.count_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.total_amount }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.note }}</td>
            <td class="ts-whitespace-no-wrap">
              <div class="ts-bg-green-100 ts-text-green-500 ts-px-2 ts-py-1 ts-rounded-lg" v-if="record.is_adjusted"
                style="width: fit-content;">Yes</div>
              <div v-else class="ts-bg-red-100 ts-text-red-500 ts-px-2 ts-py-1 ts-rounded-lg"
                style="width: fit-content;">No</div>
            </td>
            <td class="text-center ts-flex ts-space-x-3">
              <a href="#" class="ts-bg-blue-100 ts-text-blue-500 ts-rounded-lg ts-px-2 ts-py-1"
                v-tooltip="$t('inventory.operation.stock_count_entry.adjusted')"
                @click.prevent="onClickConvertToAdjust(record)">
                 <i class="fas fa-circle-notch spin" v-if="record._adjusting"></i>
                <i class="fas fa-share-square" v-else></i>
              </a>
              <a href="#" class="ts-bg-blue-100 ts-text-blue-500 ts-rounded-lg ts-px-2 ts-py-1" v-tooltip="$t('edit')"
                @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" class="ts-bg-red-100 ts-text-red-500 ts-rounded-lg ts-px-2 ts-py-1" v-tooltip="$t('delete')"
                @click.prevent="destroy(record)" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="300px">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
              :filterOption="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'stock-count-entry',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: [],
    }
  },
  computed: {
    ...mapState('stockCountEntry', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stockCountEntry.search
      },
      set(newValue) {
        this.$store.commit('stockCountEntry/SET_SEARCH', newValue)
        this.$store.commit('stockCountEntry/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.stockCountEntry.branch_id
      },
      set(newValue) {
        this.$store.commit('stockCountEntry/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('inventory.operation.stock_count_entry.branch'),
          style: 'width:15%'
        },
        {
          name: this.$t('inventory.operation.stock_count_entry.count_number'),
          style: 'width:10%'
        },
        {
          name: this.$t('inventory.operation.stock_count_entry.date'),
          style: 'width:10%'
        },
        {
          name: this.$t('inventory.operation.stock_count_entry.total_amount'),
          style: 'width:15%'
        },
        { name: this.$t('inventory.operation.stock_count_entry.note') },
        {
          name:
            this.$t('inventory.operation.stock_count_entry.adjusted'),
          style: 'width:100px'
        },
        {
          name: this.$t('inventory.operation.stock_count_entry.actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'stockCountEntry/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('stockCountEntry/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-count-entry-edit',
        params: { id: record.stock_count_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('stockCountEntry/destroy', record.stock_count_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async onClickConvertToAdjust(record) {
      record._adjusting = true
      if (await this.$confirmModal.danger('Do you want to convert to adjustment ?')) {
        // record._adjusting = true
        this.$store
          .dispatch('stockCountEntry/convertAdjustment', record.stock_count_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._adjusting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'stock-count-entry-create') {
      this.$store.commit('stockCountEntry/RESET_STATE')
    }
    next()
  }
}
</script>
